// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"19":"b2914134","30":"71f22922","172":"30f155f7","238":"8efa2f93","349":"25e51875","476":"eaa05f75","545":"add4ac8b","585":"842ffa6e","618":"373f043d","642":"8ad19d0d","838":"ab6b3829","874":"976b4a63"}[chunkId] + ".js";
};